import { getCookie } from '../cookie';
import { COOKIE_NAME } from './constants';

const getHidePhi = () =>
  getCookie(COOKIE_NAME);

export default getHidePhi;